import { useGetMeetingIntelligenceUserSettingsQuery } from 'features/meeting_intelligence'

/**
 * MI account eligibility from loaded Meeting Intelligence user settings.
 * @returns {{ eligible: boolean, isMiSettingsPending: boolean }} `isMiSettingsPending` is true while
 * the settings query has not finished its initial load — `eligible` is false in that window, so callers
 * that must not treat loading as denial (e.g. closing UI) should gate on `isMiSettingsPending`.
 */
export const useAiChatDiscoveryMiEligibleState = () => {
  const { data, isLoading, isUninitialized } = useGetMeetingIntelligenceUserSettingsQuery()

  const eligible = Boolean(data?.miEnabled) && !data?.adminDisabledNotetaker
  const isMiSettingsPending = isUninitialized || isLoading

  return { eligible, isMiSettingsPending }
}

/**
 * MI account eligibility for AI chat discovery surfaces (full-page chat, FAB, nav, right rail).
 * False when settings are not yet available (`data` undefined) or MI is off / admin-disabled.
 * Also false while settings are still loading — use {@link useAiChatDiscoveryMiEligibleState} when you
 * need to distinguish loading from loaded-but-ineligible.
 */
export const useAiChatDiscoveryMiEligible = () => {
  const { eligible } = useAiChatDiscoveryMiEligibleState()
  return eligible
}
